import React from 'react';
import {createRoot} from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import { inject } from '@vercel/analytics';
import Layout from "./layout/layout";
import AnimatedRoutes from "./components/AnimatedRoutes/AnimatedRoutes";

inject();

const root = createRoot(document.getElementById('root'));
root.render(
    <Router>
        <Layout>
            <AnimatedRoutes/>
        </Layout>
    </Router>
);